import classNames from 'classnames';
import React, { useEffect, useState } from 'react';

export interface ITab {
  label: string;
  value: string;
}

interface ITabProps {
  items: ITab[];
  defaultValue?: string;
  onChange: (value: string) => void;
}

export const Tab = ({ items, defaultValue, onChange }: ITabProps) => {
  const [value, setValue] = useState<string>(defaultValue || items[0].value);
  useEffect(() => {
    if (defaultValue) {
      setValue(defaultValue);
    }
  }, [defaultValue]);

  const handleChange = (tabValue: string) => {
    setValue(tabValue);
    onChange(tabValue);
  };
  return (
    <ul className="flex items-center flex-wrap gap-3">
      {items.map((tab) => (
        <li
          key={tab.value}
          onClick={() => {
            handleChange(tab.value);
          }}
          className={classNames(
            `font-medium border rounded-[100px] border-[#0071A6] px-4 text-base h-10 flex justify-center items-center cursor-pointer`,
            {
              'text-white bg-[#0071A6] ': value === tab.value,
              'text-[#0071A6] ': value !== tab.value,
            }
          )}
        >
          {tab.label}
        </li>
      ))}
    </ul>
  );
};
